import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import "./Shop.css";
// import ShopBg from "../../assets/Background/shopbg.avif";
import { motion } from "framer-motion";
import { FaThLarge, FaList } from "react-icons/fa";
import AboutUsVideo from "../../assets/Background/aboutusvideo.webm";
import { FaLongArrowAltDown, FaLongArrowAltUp } from "react-icons/fa";
import api from "../../api";
import { FiEye, FiShoppingCart } from "react-icons/fi";
import { useCart } from "../Cart/CartContext";
import CartDrawer from "../Cart/CartDrawer";
import { FaLongArrowAltRight } from "react-icons/fa";
import NoImage from "../../assets/no-track.avif";

const Shop = () => {
  const navigate = useNavigate();
  const [fetchedData, setFetchedData] = useState([]);
  const [shopfetchedData, setshopFetchedData] = useState([]);
  const [allCategories, setAllCategories] = useState([]);
  const [selectedMainCategories, setSelectedMainCategories] = useState([]);
  const [selectedArtists, setSelectedArtists] = useState([]);
  const [categoryDropdownOpen, setCategoryDropdownOpen] = useState(false);
  const [artistDropdownOpen, setArtistDropdownOpen] = useState(false);
  const [allDocDescAr, setAllDocDescAr] = useState([]);
  const [searchName, setSearchName] = useState("");
  // const [searchCategory, setSearchCategory] = useState("");
  const [filteredDocs, setFilteredDocs] = useState([]);
  const [viewMode, setViewMode] = useState("grid");
  const [alphabeticOrder, setAlphabeticOrder] = useState("asc");
  const [startingLetter, setStartingLetter] = useState("");
  const [cartOpen, setCartOpen] = useState(false);
  const [searchResults, setSearchResults] = useState([]);
  const [searchModalOpen, setSearchModalOpen] = useState(false);
  const [selectedCardId, setSelectedCardId] = useState(null);

  const [searchParams, setSearchParams] = useSearchParams();
  const groupId = searchParams.get("groupId");
  const categoryShop = searchParams.get("category") || "";
  const groupNameFromUrl = searchParams.get("groupName") || "";
  const [activeGroupName, setActiveGroupName] = useState("");
  const [groupFetchedData, setGroupFetchedData] = useState([]);
  const [relatedSearchProducts, setRelatedSearchProducts] = useState([]);
  const [showSearchRelated, setShowSearchRelated] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [selectedSearchItem, setSelectedSearchItem] = useState(null);
  const [open, setOpen] = useState(false);

  const cardRefs = useRef({});
  const resultsContainerRef = useRef(null);
  const [showFixedActions, setShowFixedActions] = useState(false);

  const {
    cartItems,
    addToCart,
    removeItem,
    increaseQty,
    decreaseQty,
    subtotal,
  } = useCart();

  const normalizeText = (value) => (value || "").trim().toLowerCase();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    if (!categoryShop) return;

    setSelectedMainCategories([categoryShop]);
  }, [categoryShop]);

  // Combine all datasets on mount
  useEffect(() => {
    if (shopfetchedData.length === 0) return;

    const artistMap = new Map();

    shopfetchedData.forEach((item) => {
      const normalizedArtist = normalizeText(item.artistEn);
      if (!normalizedArtist) return;

      if (!artistMap.has(normalizedArtist)) {
        artistMap.set(normalizedArtist, item.artistEn?.trim() || "");
      }
    });

    setAllDocDescAr([...artistMap.values()]);

    const uniqueCategories = [
      ...new Set(shopfetchedData.map((item) => item.category_name)),
    ];
    setAllCategories(uniqueCategories);
  }, [shopfetchedData]);

  // Filter logic
  // useEffect(() => {
  //   let results = [...shopfetchedData];

  //   if (searchName) {
  //     const lower = searchName.toLowerCase();
  //     results = results.filter(
  //       (item) =>
  //         item.titleEn.toLowerCase().includes(lower) ||
  //         item.artistEn.toLowerCase().includes(lower),
  //     );
  //   }

  //   if (searchCategory) {
  //     results = results.filter((item) => item.artistEn === searchCategory);
  //   }

  //   if (searchMainCategory) {
  //     results = results.filter(
  //       (item) => item.category_name === searchMainCategory,
  //     );
  //   }

  //   setFilteredDocs(results);
  // }, [searchName, searchCategory, searchMainCategory, shopfetchedData]);
  // useEffect(() => {
  //   let results = [...shopfetchedData];

  //   const lower = searchName.trim().toLowerCase();

  //   if (lower.length >= 1) {
  //     results = results.filter(
  //       (item) =>
  //         (item.titleEn || "").toLowerCase().includes(lower) ||
  //         (item.artistEn || "").toLowerCase().includes(lower)
  //     );
  //   }

  //   if (searchCategory) {
  //     results = results.filter(
  //       (item) => (item.artistEn || "").toLowerCase() === searchCategory.toLowerCase()
  //     );
  //   }

  //   if (searchMainCategory) {
  //     results = results.filter(
  //       (item) =>
  //         (item.category_name || "").toLowerCase() === searchMainCategory.toLowerCase()
  //     );
  //   }

  //   setFilteredDocs(results);
  // }, [searchName, searchCategory, searchMainCategory, shopfetchedData]);

  function splitTitleIntoGroups(title, groups = 2) {
    const words = title.trim().split(" ");
    const result = [];

    const size = Math.ceil(words.length / groups);

    for (let i = 0; i < groups; i++) {
      const chunk = words.slice(i * size, (i + 1) * size);
      if (chunk.length) {
        result.push(chunk.join(" "));
      }
    }

    return result;
  }
  // const parts = splitTitleIntoGroups(title, 2);

  const fetchAllShopData = async () => {
    try {
      const formData = new FormData();
      const res = await api.post("shop/show_shop", formData);
      setFetchedData(res.data);
    } catch (err) {
      console.error(err);
      setFetchedData([]);
    }
  };

  const fetchShopData = async () => {
    try {
      const formData = new FormData();
      const res = await api.post("shop/show_shop", formData);
      setshopFetchedData(res.data);
      setFetchedData(res.data);
    } catch (err) {
      console.error(err);
      setshopFetchedData([]);
      setFetchedData([]);
    }
  };

  const fetchGroupData = async () => {
    try {
      if (!groupId) {
        setGroupFetchedData([]);
        setActiveGroupName("");
        return;
      }

      const res = await api.post("shop/group", { groupId });
      setGroupFetchedData(res.data || []);
      setActiveGroupName(
        groupNameFromUrl || res.data?.[0]?.carousel_group_name || "",
      );
    } catch (err) {
      console.error(err);
      setGroupFetchedData([]);
      setActiveGroupName("");
    }
  };

  useEffect(() => {
    fetchShopData();
  }, []);

  useEffect(() => {
    fetchGroupData();
  }, [groupId, groupNameFromUrl]);

  // Show fixed actions after user scrolls past 700px
  useEffect(() => {
    const onScroll = () => {
      try {
        setShowFixedActions(window.scrollY > 400);
      } catch (e) {
        // ignore (server-side rendering)
      }
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // ALPHABETICALLY Sort
  // useEffect(() => {
  //   let results = [...shopfetchedData];
  //   if (searchName) {
  //     const lower = searchName.toLowerCase();
  //     results = results.filter(
  //       (item) =>
  //         item.titleEn.toLowerCase().includes(lower) ||
  //         item.artistEn.toLowerCase().includes(lower),
  //     );
  //   }

  //   if (searchCategory) {
  //     results = results.filter((item) => item.artistEn === searchCategory);
  //   }

  //   if (searchMainCategory) {
  //     results = results.filter(
  //       (item) => item.category_name === searchMainCategory,
  //     );
  //   }

  //   // SORT ALPHABETICALLY BY TITLE
  //   results.sort((a, b) => {
  //     const artistA = a.artistEn?.toLowerCase() || "";
  //     const artistB = b.artistEn?.toLowerCase() || "";
  //     return alphabeticOrder === "asc"
  //       ? artistA.localeCompare(artistB)
  //       : artistB.localeCompare(artistA);
  //   });

  //   setFilteredDocs(results);
  // }, [
  //   searchName,
  //   searchCategory,
  //   searchMainCategory,
  //   shopfetchedData,
  //   alphabeticOrder,
  // ]);

  const inputRef = useRef(null);

  const toggleSelectedValue = (value, setter) => {
    setter((prev) =>
      prev.includes(value)
        ? prev.filter((item) => item !== value)
        : [...prev, value]
    );
  };

  const getDropdownLabel = (selectedItems, defaultLabel) => {
    if (selectedItems.length === 0) return defaultLabel;
    if (selectedItems.length === 1) return selectedItems[0];
    return `${selectedItems.length} selected`;
  };


  const removeSelectedCategory = (value) => {
    setSelectedMainCategories((prev) =>
      prev.filter((item) => item !== value)
    );
  };

  const removeSelectedArtist = (value) => {
    setSelectedArtists((prev) =>
      prev.filter((item) => item !== value)
    );
  };

  const hasActiveFilterChips =
    selectedMainCategories.length > 0 || selectedArtists.length > 0;
  useEffect(() => {
    let results = [...shopfetchedData];
    const lower = normalizeText(searchName);

    if (lower) {
      results = results.filter(
        (item) =>
          normalizeText(item.titleEn).includes(lower) ||
          normalizeText(item.titleAr).includes(lower),
      );
    }

    if (selectedArtists.length > 0) {
      const selectedArtistSet = new Set(selectedArtists.map(normalizeText));

      results = results.filter((item) =>
        selectedArtistSet.has(normalizeText(item.artistEn))
      );
    }

    if (selectedMainCategories.length > 0) {
      const selectedCategorySet = new Set(
        selectedMainCategories.map(normalizeText)
      );

      results = results.filter((item) =>
        selectedCategorySet.has(normalizeText(item.category_name))
      );
    }

    if (startingLetter) {
      const start = normalizeText(startingLetter);
      results = results.filter((item) => {
        const artist = normalizeText(item.artistEn || item.artistAr);
        return artist.startsWith(start);
      });
    }

    results.sort((a, b) => {
      const artistA = normalizeText(a.artistEn);
      const artistB = normalizeText(b.artistEn);
      return alphabeticOrder === "asc"
        ? artistA.localeCompare(artistB)
        : artistB.localeCompare(artistA);
    });

    setFilteredDocs(results);

    if (lower.length >= 1) {
      const matches = [
        ...new Map(
          shopfetchedData
            .filter(
              (item) =>
                normalizeText(item.titleEn).includes(lower) ||
                normalizeText(item.titleAr).includes(lower) ||
                normalizeText(item.artistEn).includes(lower) ||
                normalizeText(item.artistAr).includes(lower),
            )
            .map((item) => [item.id, item]),
        ).values(),
      ];

      setSearchResults(matches);
    } else {
      setSearchResults([]);
      setSearchModalOpen(false);
    }
  }, [
    searchName,
    selectedArtists,
    selectedMainCategories,
    shopfetchedData,
    alphabeticOrder,
    startingLetter,
  ]);

  const handleSearchResultClick = (item) => {
    setSearchName(item.titleEn || item.titleAr || "");
    setSelectedCardId(item.id);

    setSelectedSearchItem(item);
    setShowSearchRelated(true);

    closeSearchModal();
    inputRef.current?.blur();
  };

  const cleanedRelatedSearchProducts = relatedSearchProducts.filter(
    (product) => product.id !== selectedSearchItem?.id,
  );
  useEffect(() => {
    if (!selectedCardId) return;

    const el = cardRefs.current[selectedCardId];
    if (el) {
      el.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });

      el.classList.add("shop-card-highlight");

      const timer = setTimeout(() => {
        el.classList.remove("shop-card-highlight");
        setSelectedCardId(null);
      }, 1800);

      return () => clearTimeout(timer);
    }
  }, [filteredDocs, selectedCardId]);

  const goToProduct = (id) => {
    navigate(`/products/${id}`);
  };

  const closeGroupModal = () => {
    setSearchParams({});
    setActiveGroupName("");
  };
  useEffect(() => {
    if (!groupId) {
      document.body.style.overflow = "";
      return;
    }

    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = "";
    };
  }, [groupId]);

  useEffect(() => {
    if (!startingLetter || filteredDocs.length === 0) return;

    const timer = setTimeout(() => {
      const firstResult =
        resultsContainerRef.current?.querySelector(".artist-result-section");

      firstResult?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }, 50);

    return () => clearTimeout(timer);
  }, [startingLetter, filteredDocs]);


  const isGroupMode = !!groupId;
  const groupBaseItems = isGroupMode ? groupFetchedData : [];

  const groupBaseIds = new Set(groupBaseItems.map((item) => item.id));

  const groupCategories = new Set(
    groupBaseItems
      .map((item) => normalizeText(item.category_name))
      .filter(Boolean),
  );

  const relatedGroupProducts = isGroupMode
    ? [
      ...new Map(
        fetchedData
          .filter((item) => !groupBaseIds.has(item.id))
          .filter((item) => {
            const normalizedCategory = normalizeText(item.category_name);
            return (
              normalizedCategory && groupCategories.has(normalizedCategory)
            );
          })
          .map((item) => [item.id, item]),
      ).values(),
    ].slice(0, 8)
    : [];

  const firstSearchArtist = showSearchRelated
    ? selectedSearchItem?.artistEn?.trim() || ""
    : "";

  const firstSearchId = showSearchRelated ? selectedSearchItem?.id : null;
  useEffect(() => {
    const fetchRelatedSearchProducts = async () => {
      if (!showSearchRelated || !firstSearchArtist || !firstSearchId) {
        setRelatedSearchProducts([]);
        return;
      }

      try {
        const formData = new FormData();
        formData.append("artistEn", firstSearchArtist);
        formData.append("productId", firstSearchId);

        const res = await api.post("categorycarousel/getRelatives", formData);
        setRelatedSearchProducts(res.data || []);
      } catch (err) {
        console.error(err);
        setRelatedSearchProducts([]);
      }
    };

    fetchRelatedSearchProducts();
  }, [showSearchRelated, firstSearchArtist, firstSearchId]);

  const closeSearchModal = () => {
    setSearchModalOpen(false);
  };

  const handleResetFilters = () => {
    setSearchName("");
    setSelectedArtists([]);
    setSelectedMainCategories([]);
    setStartingLetter("");
    setAlphabeticOrder("asc");
    setCategoryDropdownOpen(false);
    setArtistDropdownOpen(false);
    setSearchParams({});
  };

  return (
    <>
      {/* <div
                  className="fatf__container position-relative"
                  style={{
                      backgroundImage: `url(${ShopBg})`,
                      backgroundPosition: "center center",
                      backgroundSize: "cover",
                      height: "500px",
                      boxShadow: "3px 4px 7px 5px #0000008a",
                  }}
              >
                  <div className="fatf_overlay"></div>
                  <div
                      className="fatf__content w-50 text-center d-flex flex-column justify-content-center align-items-center mx-auto"
                      style={{ zIndex: "5" }}
                  >
                      <h1 className="text-white">The Vinyl Shop</h1>
                      <h4 className="text-white">Browse Vinyl by Artist</h4>
                  </div>
              </div> */}
      <div className="contactus-video-section">
        <video
          className="contactus__video"
          src={AboutUsVideo}
          autoPlay
          loop
          muted
          playsInline
        />
        <div className="contactus_overlay" />
        <h1 className="contactus-title">The Vinyl Shop</h1>
        {/* <h4 className="contactus-subtitle">Browse Vinyl by Artist</h4> */}
      </div>

      <div className="title_business">
        <div className="container-xl">
          {/* FILTER BAR */}
          <div className="shadow-container d-flex flex-wrap gap-3 mb-4">
            <div
              className="shop-search-box"
              style={{ maxWidth: "300px", width: "100%" }}
            >
              <input
                ref={inputRef}
                type="text"
                placeholder="Search by album or artistname"
                value={searchName}
                onFocus={() => {
                  if (searchName.trim() && searchResults.length > 0) {
                    setShowDropdown(true);
                  }
                }}
                onBlur={() => {
                  // delay so click works
                  setTimeout(() => setShowDropdown(false), 150);
                }}
                onChange={(e) => {
                  const value = e.target.value;
                  setSearchName(value);
                  setShowDropdown(value.trim().length > 0);
                  // Close related products when user starts new search
                  if (value !== searchName) {
                    setShowSearchRelated(false);
                  }
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();

                    const query = searchName.trim();
                    if (!query) return;

                    // FILTER RESULTS BEFORE NAVIGATING
                    const results = shopfetchedData.filter(
                      (item) =>
                        normalizeText(item.titleEn).includes(
                          normalizeText(query),
                        ) ||
                        normalizeText(item.artistEn).includes(
                          normalizeText(query),
                        ),
                    );

                    navigate("/search", {
                      state: { allProducts: results },
                    });

                    setShowDropdown(false);
                  }
                }}
                className="form-control groupingby-input"
              />
              {showDropdown && searchResults.length > 0 && (
                <div className="search-dropdown">
                  {searchResults.map((item) => (
                    <div
                      key={item.id}
                      className="search-dropdown-item"
                      onMouseDown={() => handleSearchResultClick(item)}
                    >
                      <div>
                        <img
                          src={
                            !item.cover_front ||
                              item.cover_front.trim().toLowerCase() === "n/a"
                              ? NoImage
                              : `http://api.righttracklb.com/assets/images/${item.cover_front}`
                          }
                          alt={item.titleEn}
                          onError={(e) => {
                            e.target.onerror = null; // prevent infinite loop
                            e.target.src = NoImage;
                          }}
                          loading="lazy"
                        />
                      </div>
                      <div className="d-flex flex-column">
                        <div className="title">
                          {item.titleEn || item.titleAr}
                        </div>
                        <div className="subtitle">{item.artistEn}</div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
            {/* <button
                onClick={() =>
                  setAlphabeticOrder((prev) => (prev === "asc" ? "desc" : "asc"))
                }
                className="btn btn-control"
                style={{ minWidth: "120px" }}
              >
                {alphabeticOrder === "asc" ? (
                  <FaLongArrowAltUp />
                ) : (
                  <FaLongArrowAltDown />
                )}
                {alphabeticOrder === "asc" ? "A → Z" : "Z → A"}
              </button> */}
            <div className="sort-group">
              <button
                onClick={() =>
                  setAlphabeticOrder((prev) =>
                    prev === "asc" ? "desc" : "asc",
                  )
                }
                className="btn btn-control"
              >
                <span className="btn-icon">
                  {alphabeticOrder === "asc" ? (
                    <FaLongArrowAltUp className="icon-up" />
                  ) : (
                    <FaLongArrowAltDown className="icon-down" />
                  )}
                </span>
                {/* <span className="btn-text">
        {alphabeticOrder === "asc" ? "A → Z" : "Z → A"}
      </span> */}
              </button>
              {/* <div className="filter-label" style={{ padding: "4px" }}>
                  ABC Filter By Artist
                </div> */}
              {/* <select
                  value={startingLetter}
                  onChange={(e) => setStartingLetter(e.target.value)}
                  className="groupingby-select"
                >
                  {/* <option value="" DEFAULT>
                    ABC Filter By Artist
                  </option> */}

              {/* {Array.from({ length: 26 }, (_, i) =>
                    String.fromCharCode(65 + i),
                  ).map((letter) => (
                    <option key={letter} value={letter}>
                      {letter}
                    </option>
                  ))}
                </select> */}
              <div className="letter-filter">
                <button
                  className="groupingby-select"
                  onClick={() => setOpen(!open)}
                >
                  {startingLetter || "ABC Filter By Artist"}
                </button>

                {open && (
                  <div className="letter-modal-overlay" onClick={() => setOpen(false)}>
                    <div className="letter-modal" onClick={(e) => e.stopPropagation()}>
                      <button
                        className={`letter-item ${startingLetter === "" ? "active" : ""}`}
                        onClick={() => {
                          setStartingLetter("");
                          setOpen(false);
                        }}
                        style={{ width: "100%", marginBottom: "10px" }}
                      >
                        None
                      </button>
                      {Array.from({ length: 26 }, (_, i) =>
                        String.fromCharCode(65 + i)
                      ).reduce((rows, letter, i) => {
                        if (i % 5 === 0) rows.push([]);
                        rows[rows.length - 1].push(letter);
                        return rows;
                      }, []).map((row, rowIndex) => (
                        <div key={rowIndex} className="letter-row">
                          {row.map((letter) => (
                            <button
                              key={letter}
                              className={`letter-item ${startingLetter === letter ? "active" : ""
                                }`}
                              onClick={() => {
                                setStartingLetter(letter);
                                setOpen(false);
                              }}
                            >
                              {letter}
                            </button>
                          ))}
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="multi-filter-dropdown" style={{ maxWidth: "200px", width: "100%" }}>
              <button
                type="button"
                className="form-select groupingby-select"
                onClick={() => setCategoryDropdownOpen((prev) => !prev)}
              >
                {getDropdownLabel(selectedMainCategories, "All Genres")}
              </button>

              {categoryDropdownOpen && (
                <div className="multi-filter-menu">
                  {allCategories.map((cat, index) => (
                    <label key={index} className="multi-filter-item">
                      <input
                        type="checkbox"
                        style={{ width: 'fit-content' }}
                        checked={selectedMainCategories.includes(cat)}
                        onChange={() =>
                          toggleSelectedValue(cat, setSelectedMainCategories)
                        }
                      />
                      <span>{cat}</span>
                    </label>
                  ))}
                </div>
              )}
            </div>

            <div className="multi-filter-dropdown" style={{ maxWidth: "200px", width: "100%" }}>
              <button
                type="button"
                className="form-select groupingby-select"
                onClick={() => setArtistDropdownOpen((prev) => !prev)}
              >
                {getDropdownLabel(selectedArtists, "All Artists")}
              </button>

              {artistDropdownOpen && (
                <div className="multi-filter-menu">
                  {allDocDescAr.map((artist, index) => (
                    <label key={index} className="multi-filter-item">
                      <input
                        type="checkbox"
                        checked={selectedArtists.includes(artist)}
                        onChange={() => toggleSelectedValue(artist, setSelectedArtists)}
                      />
                      <span>{artist}</span>
                    </label>
                  ))}
                </div>
              )}
            </div>

            <div className="icon-tooltip-wrap">
              <FaThLarge
                onClick={() => setViewMode("grid")}
                size={40}
                className={`groupingby_style_button ${viewMode === "grid" ? "active" : ""}`}
                color={viewMode === "grid" ? "#fff" : "#666"}
              />
              <span className="icon-tooltip-text">Switch to grid View</span>
            </div>

            <div className="icon-tooltip-wrap">
              <FaList
                onClick={() => setViewMode("list")}
                size={40}
                className={`groupingby_style_button ${viewMode === "list" ? "active" : ""}`}
                color={viewMode === "list" ? "#fff" : "#666"}
              />
              <span className="icon-tooltip-text">Switch to linear View</span>
            </div>
            <div>
              <button
                className="form-control sort-group"
                onClick={handleResetFilters}
              >Reset Filters</button>
            </div>
          </div>

          {hasActiveFilterChips && (
            <div className="selected-filter-chips-wrap mb-4">
              {selectedMainCategories.map((cat) => (
                <button
                  key={`genre-${cat}`}
                  type="button"
                  className="selected-filter-chip genre-chip"
                  onClick={() => removeSelectedCategory(cat)}
                  title={`Remove ${cat}`}
                >
                  <span className="selected-filter-chip-label">Genre</span>
                  <span className="selected-filter-chip-text">{cat}</span>
                  <span className="selected-filter-chip-close">×</span>
                </button>
              ))}

              {selectedArtists.map((artist) => (
                <button
                  key={`artist-${artist}`}
                  type="button"
                  className="selected-filter-chip artist-chip"
                  onClick={() => removeSelectedArtist(artist)}
                  title={`Remove ${artist}`}
                >
                  <span className="selected-filter-chip-label">Artist</span>
                  <span className="selected-filter-chip-text">{artist}</span>
                  <span className="selected-filter-chip-close">×</span>
                </button>
              ))}
            </div>
          )}

          {/* Carousel Group */}
          {/* {groupId && (
              <div className="shop-group-banner shadow-container mb-4">
                <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                  <div>
                    <h3 className="mb-1">Showing Group: {activeGroupName || "Selected Group"}</h3>
                    <p className="mb-0">All filters below now apply only to this group.</p>
                  </div>

                  <button
                    className="modern-sort-btn"
                    onClick={() => {
                      setSearchParams({});
                      setSearchName("");
                      setSearchCategory("");
                      setSearchMainCategory("");
                    }}
                  >
                    <span className="btn-text">Clear Group Filter</span>
                  </button>
                </div>
              </div>
            )} */}

          <div ref={resultsContainerRef}>
            {[...allDocDescAr]
              .sort((a, b) =>
                alphabeticOrder === "asc"
                  ? normalizeText(a).localeCompare(normalizeText(b))
                  : normalizeText(b).localeCompare(normalizeText(a)),
              )
              .map((artist, index1) => {
                const matchingItems = [
                  ...new Map(
                    filteredDocs
                      .filter(
                        (item) =>
                          normalizeText(item.artistEn) ===
                          normalizeText(artist),
                      )
                      .map((item) => [item.id, item]),
                  ).values(),
                ];
                if (matchingItems.length === 0) return null;
                const parts = splitTitleIntoGroups(artist, 2);
                return (
                  <React.Fragment key={index1}>
                    <div className="row mb-5 shadow-container justify-content-start artist-result-section">
                      <div className="col-12 text-center mb-4">
                        <h1 className="category-title">
                          <motion.div
                            initial={{ opacity: 0, y: 25 }}
                            whileInView={{ opacity: 1, y: 0, scale: 1 }}
                            viewport={{ once: false, amount: 0.3 }}
                            transition={{ duration: 0.5, ease: "easeOut" }}
                          >
                            {/* {artist} */}
                            {parts.map((part, index) => (
                              <span
                                key={index}
                                className={`category-part category-part-${index}`}
                              >
                                {part}
                              </span>
                            ))}
                          </motion.div>
                          <div className="category-divider" />
                        </h1>
                      </div>
                      {(searchName.trim()
                        ? matchingItems
                        : matchingItems.slice(0, 8)
                      ).map((item) => (
                        <div
                          key={item.id}
                          ref={(el) => {
                            if (el) cardRefs.current[item.id] = el;
                          }}
                          className={
                            viewMode === "grid"
                              ? "col-6 col-md-3 mb-4 d-flex justify-content-center"
                              : "col-12 mb-3"
                          }
                        >
                          <div
                            className={
                              viewMode === "grid"
                                ? "new-business__card-container"
                                : "new-business__list-container row"
                            }
                          >
                            <div
                              onClick={() => goToProduct(item.id)}
                              className={
                                viewMode === "grid"
                                  ? "image-icon-wrapper"
                                  : "image-icon-wrapper col-md-3"
                              }
                            >
                              <div className="new_card_business-overlay">
                                <div className="new_card_business-readmore">
                                  View →
                                </div>
                              </div>
                              <img
                                src={
                                  !item.cover_front ||
                                    item.cover_front.trim().toLowerCase() ===
                                    "n/a"
                                    ? NoImage
                                    : `http://api.righttracklb.com/assets/images/${item.cover_front}`
                                }
                                alt={item.titleEn}
                                onError={(e) => {
                                  e.target.onerror = null; // prevent infinite loop
                                  e.target.src = NoImage;
                                }}
                                loading="lazy"
                              />
                              <div className="vinyl-table-shadow-shop shadow-front-shop"></div>
                            </div>

                            <div
                              className={
                                viewMode === "grid"
                                  ? "new-business__card-content"
                                  : "new-business__card-content col-md-8"
                              }
                            >
                              <h4 className="fw-bold">
                                {item.titleEn?.length > 40
                                  ? item.titleEn?.slice(0, 40) + "…"
                                  : item.titleEn}
                              </h4>
                              <h3 className="new-business__card-type fw-bold">
                                {item.artistEn}
                              </h3>
                              {/* <div className="new-business__card-type">
                                ${item.price}
                              </div> */}
                              <div className="d-flex flex-row align-items-center justify-content-between gap-3 mt-2">
                                {/* <p className="price mb-0">{item.price} $</p> */}
                                <p
                                  className={`price mb-0 ${item.qty === 0 ? "out-of-stock-price" : ""}`}
                                >
                                  {item.price} $
                                </p>

                                {item.qty === 0 && (
                                  <p className="out-of-stock-text">Sold Out</p>
                                )}

                                <div className="d-flex gap-2 icon-group">
                                  <Link
                                    to={`/products/${item.id}`}
                                    className="icon-btn-shop view-btn"
                                    title="View"
                                  >
                                    <FiEye size={18} />
                                  </Link>

                                  {/* <button className="icon-btn cart-btn" title="Add to cart" onClick={() => onAddToCart?.(item)}>
                                                                              <FiShoppingCart size={18} />
                                                                          </button> */}
                                  {/* <button
                                    className="icon-btn-shop cart-btn"
                                    title={item.qty === 0 ? "Out of stock" : "Add to cart"}
                                    disabled={item.qty === 0}
                                    onClick={() => {
                                      if (item.qty > 0) {
                                        addToCart?.(item);
                                        setCartOpen(true);
                                      }
                                    }}

                                  > <FiShoppingCart size={18} /></button> */}
                                  <button
                                    className="icon-btn-shop cart-btn"
                                    title={
                                      item.qty === 0
                                        ? "Out of stock"
                                        : "Add to cart"
                                    }
                                    disabled={item.qty === 0}
                                    onClick={(e) => {
                                      if (item.qty > 0) {
                                        const card = e.currentTarget.closest(
                                          ".new-business__card-container, .new-business__list-container",
                                        );
                                        const sourceImg = card?.querySelector(
                                          ".image-icon-wrapper img",
                                        );

                                        addToCart?.(item, 1, sourceImg);
                                      }
                                    }}
                                  >
                                    <FiShoppingCart size={18} />
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                      {matchingItems.length > 8 && (
                        <div className="col-12 text-center mt-3">
                          <Link
                            to={`/artist/${encodeURIComponent(artist)}`}
                            state={{ allProducts: matchingItems }}
                            className="shop-view-btn"
                          >
                            <div className="shop-view-final">
                              <span className="shop-view"> View More</span>
                              <span className="arrow">
                                <FaLongArrowAltRight size={20} />
                              </span>
                            </div>
                          </Link>
                        </div>
                      )}
                    </div>
                  </React.Fragment>
                );
              })}
          </div>
        </div>
        {/* Fixed action group: alphabetic order toggle + letter filter toggle (shows after 700px scroll) */}
        {showFixedActions && (
          <div className="fixed-action-group sort-group">
            <button
              className="order-fixed-button btn btn-control"
              onClick={() => {
                setAlphabeticOrder((prev) => (prev === "asc" ? "desc" : "asc"));
                const firstArtist = document.querySelector('.row.mb-5.shadow-container .category-title');
                if (firstArtist) {
                  firstArtist.scrollIntoView({
                    behavior: "smooth",
                    block: "start"
                  });
                }
              }}
              title={alphabeticOrder === "asc" ? "A → Z" : "Z → A"}
            >
              <span className="btn-icon">
                {alphabeticOrder === "asc" ? (
                  <FaLongArrowAltUp className="icon-up" />
                ) : (
                  <FaLongArrowAltDown className="icon-down" />
                )}
              </span>
            </button>

            <button
              className="order-fixed-button btn btn-control w-100"
              onClick={() => setOpen((v) => !v)}
              aria-label="Toggle ABC Filter"
            >
              {startingLetter || "ABC"}
            </button>
          </div>
        )}

        <CartDrawer
          isOpen={cartOpen}
          onClose={() => setCartOpen(false)}
          items={cartItems}
          onRemoveItem={removeItem}
          onIncreaseQty={increaseQty}
          onDecreaseQty={decreaseQty}
          onViewCart={() => navigate("/cart")}
          onCheckout={() => navigate("/CheckOut")}
          onContinueShopping={() => setCartOpen(false)}
        />

        {isGroupMode && (
          <div className="shop-group-modal-overlay" onClick={closeGroupModal}>
            <div
              className="shop-group-modal"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="shop-group-modal-header">
                <div>
                  <h3 className="mb-1 grp-title">
                    {activeGroupName || "Selected Group"}
                  </h3>
                </div>

                <button
                  type="button"
                  className="modern-sort-btn"
                  onMouseDown={closeGroupModal}
                >
                  <span className="btn-text">Close</span>
                </button>
              </div>

              <div className="shop-group-modal-body">
                <div className="row mb-5 shadow-container justify-content-start">
                  <div className="col-12 text-center mb-4">
                    <h1 className="category-title">
                      <motion.div
                        initial={{ opacity: 0, y: 25 }}
                        whileInView={{ opacity: 1, y: 0, scale: 1 }}
                        viewport={{ once: false, amount: 0.3 }}
                        transition={{ duration: 0.5, ease: "easeOut" }}
                      >
                        {activeGroupName || "Group Products"}
                      </motion.div>
                      <div className="category-divider" />
                    </h1>
                  </div>

                  {groupBaseItems.map((item) => (
                    <div
                      key={item.id}
                      className={
                        viewMode === "grid"
                          ? "col-6 col-md-3 mb-4 d-flex justify-content-center"
                          : "col-12 mb-3"
                      }
                    >
                      <div
                        className={
                          viewMode === "grid"
                            ? "new-business__card-container"
                            : "new-business__list-container row"
                        }
                      >
                        <div
                          onClick={() => goToProduct(item.id)}
                          className={
                            viewMode === "grid"
                              ? "image-icon-wrapper"
                              : "image-icon-wrapper col-md-3"
                          }
                        >
                          <div className="new_card_business-overlay">
                            <div className="new_card_business-readmore">
                              View →
                            </div>
                          </div>
                          <img
                            src={
                              !item.cover_front ||
                                item.cover_front.trim().toLowerCase() === "n/a"
                                ? NoImage
                                : `http://api.righttracklb.com/assets/images/${item.cover_front}`
                            }
                            alt={item.titleEn}
                            onError={(e) => {
                              e.target.onerror = null; // prevent infinite loop
                              e.target.src = NoImage;
                            }}
                            loading="lazy"
                          />
                          <div className="vinyl-table-shadow-shop shadow-front-shop"></div>
                        </div>

                        <div
                          className={
                            viewMode === "grid"
                              ? "new-business__card-content"
                              : "new-business__card-content col-md-8"
                          }
                        >
                          <h4 className="fw-bold">{item.artistEn}</h4>
                          <h3 className="new-business__card-type fw-bold">
                            {item.titleEn?.length > 40
                              ? item.titleEn?.slice(0, 40) + "…"
                              : item.titleEn}
                          </h3>

                          <div className="d-flex flex-row align-items-center justify-content-between gap-3 mt-2">
                            <p
                              className={`price mb-0 ${item.qty === 0 ? "out-of-stock-price" : ""}`}
                            >
                              {item.price} $
                            </p>

                            {item.qty === 0 && (
                              <p className="out-of-stock-text">Sold Out</p>
                            )}

                            <div className="d-flex gap-2 icon-group">
                              <Link
                                to={`/products/${item.id}`}
                                className="icon-btn-shop view-btn"
                                title="View"
                              >
                                <FiEye size={18} />
                              </Link>

                              <button
                                className="icon-btn-shop cart-btn"
                                title={
                                  item.qty === 0
                                    ? "Out of stock"
                                    : "Add to cart"
                                }
                                disabled={item.qty === 0}
                                onClick={(e) => {
                                  if (item.qty > 0) {
                                    const card = e.currentTarget.closest(
                                      ".new-business__card-container, .new-business__list-container",
                                    );
                                    const sourceImg = card?.querySelector(
                                      ".image-icon-wrapper img",
                                    );

                                    addToCart?.(item, 1, sourceImg);
                                  }
                                }}
                              >
                                <FiShoppingCart size={18} />
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                {relatedGroupProducts.length > 0 && (
                  <div className="row mb-0 shadow-container justify-content-start">
                    <div className="col-12 text-center mb-4">
                      <h1 className="category-title">
                        <motion.div
                          initial={{ opacity: 0, y: 25 }}
                          whileInView={{ opacity: 1, y: 0, scale: 1 }}
                          viewport={{ once: false, amount: 0.3 }}
                          transition={{ duration: 0.5, ease: "easeOut" }}
                        >
                          Related{" "}
                          <span className="category-part-1">Products</span>
                        </motion.div>
                        <div className="category-divider" />
                      </h1>
                    </div>

                    {relatedGroupProducts.map((item) => (
                      <div
                        key={`related-${item.id}`}
                        className={
                          viewMode === "grid"
                            ? "col-6 col-md-3 mb-4 d-flex justify-content-center"
                            : "col-12 mb-3"
                        }
                      >
                        <div
                          className={
                            viewMode === "grid"
                              ? "new-business__card-container"
                              : "new-business__list-container row"
                          }
                        >
                          <div
                            onClick={() => goToProduct(item.id)}
                            className={
                              viewMode === "grid"
                                ? "image-icon-wrapper"
                                : "image-icon-wrapper col-md-3"
                            }
                          >
                            <div className="new_card_business-overlay">
                              <div className="new_card_business-readmore">
                                View →
                              </div>
                            </div>
                            <img
                              src={
                                !item.cover_front ||
                                  item.cover_front.trim().toLowerCase() === "n/a"
                                  ? NoImage
                                  : `http://api.righttracklb.com/assets/images/${item.cover_front}`
                              }
                              alt={item.titleEn}
                              onError={(e) => {
                                e.target.onerror = null; // prevent infinite loop
                                e.target.src = NoImage;
                              }}
                              loading="lazy"
                            />
                            <div className="vinyl-table-shadow-shop shadow-front-shop"></div>
                          </div>

                          <div
                            className={
                              viewMode === "grid"
                                ? "new-business__card-content"
                                : "new-business__card-content col-md-8"
                            }
                          >
                            <h4 className="fw-bold">
                              {item.titleEn?.length > 40
                                ? item.titleEn?.slice(0, 40) + "…"
                                : item.titleEn}
                            </h4>
                            <h3 className="new-business__card-type fw-bold">
                              {item.artistEn}
                            </h3>

                            <div className="d-flex flex-row align-items-center justify-content-between gap-3 mt-2">
                              <p
                                className={`price mb-0 ${item.qty === 0 ? "out-of-stock-price" : ""}`}
                              >
                                {item.price} $
                              </p>

                              {item.qty === 0 && (
                                <p className="out-of-stock-text">Sold Out</p>
                              )}

                              <div className="d-flex gap-2 icon-group">
                                <Link
                                  to={`/products/${item.id}`}
                                  className="icon-btn-shop view-btn"
                                  title="View"
                                >
                                  <FiEye size={18} />
                                </Link>

                                <button
                                  className="icon-btn-shop cart-btn"
                                  title={
                                    item.qty === 0
                                      ? "Out of stock"
                                      : "Add to cart"
                                  }
                                  disabled={item.qty === 0}
                                  onClick={(e) => {
                                    if (item.qty > 0) {
                                      const card = e.currentTarget.closest(
                                        ".new-business__card-container, .new-business__list-container",
                                      );
                                      const sourceImg = card?.querySelector(
                                        ".image-icon-wrapper img",
                                      );

                                      addToCart?.(item, 1, sourceImg);
                                    }
                                  }}
                                >
                                  <FiShoppingCart size={18} />
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
        {/* {searchModalOpen && (
            <div
              className="shop-search-modal-overlay"
              onClick={closeSearchModal}
            >
              <div
                className="shop-search-modal"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="shop-search-modal-header">
                  Search Results
                </div>

                <div className="shop-search-modal-content">
                  <div className="shop-search-modal-body">
                    {searchResults.length > 0 ? (
                      searchResults.map((item) => (
                        <div
                          key={item.id}
                          className="shop-search-result-item"
                          onClick={() => handleSearchResultClick(item)}
                        >
                          <div className="shop-search-result-title">
                            {item.titleEn || item.titleAr}
                          </div>

                          <div className="shop-search-result-subtitle">
                            {item.titleAr && item.titleAr !== item.titleEn ? item.titleAr : ""}
                            {item.artistEn ? ` • ${item.artistEn}` : ""}
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="shop-search-empty">No results found</div>
                    )}
                  </div> */}

        <div className="container">
          {showSearchRelated && cleanedRelatedSearchProducts.length > 0 && (
            <div className="row shadow-container justify-content-start">
              <div className="col-12 mb-4">
                <div className="d-flex justify-content-between align-items-center flex-wrap">
                  {/* TITLE */}
                  <h1 className="category-title mb-0">
                    <motion.div
                      initial={{ opacity: 0, y: 25 }}
                      whileInView={{ opacity: 1, y: 0, scale: 1 }}
                      viewport={{ once: false, amount: 0.3 }}
                      transition={{ duration: 0.5, ease: "easeOut" }}
                    >
                      <span className="category-part category-part-0">
                        Related{" "}
                      </span>
                      <span className="category-part category-part-1">
                        Products
                      </span>
                    </motion.div>
                    <div className="category-divider" />
                  </h1>

                  {/* BUTTON */}
                  <button
                    className="modern-sort-btn"
                    onClick={() => setShowSearchRelated(false)}
                  >
                    <span className="btn-text">Close</span>
                  </button>
                </div>
              </div>

              {cleanedRelatedSearchProducts.map((item) => (
                <div
                  key={`related-${item.id}`}
                  className={
                    viewMode === "grid"
                      ? "col-6 col-md-3 mb-4 d-flex justify-content-center"
                      : "col-12 mb-3"
                  }
                >
                  <div
                    className={
                      viewMode === "grid"
                        ? "new-business__card-container"
                        : "new-business__list-container row"
                    }
                  >
                    <div
                      onClick={() => {
                        goToProduct(item.id);
                        setSearchModalOpen(false);
                      }}
                      className={
                        viewMode === "grid"
                          ? "image-icon-wrapper"
                          : "image-icon-wrapper col-md-3"
                      }
                    >
                      <div className="new_card_business-overlay">
                        <div className="new_card_business-readmore">View →</div>
                      </div>

                      <img
                        src={
                          !item.cover_front ||
                            item.cover_front.trim().toLowerCase() === "n/a"
                            ? NoImage
                            : `http://api.righttracklb.com/assets/images/${item.cover_front}`
                        }
                        alt={item.titleEn}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = NoImage;
                        }}
                        loading="lazy"
                      />

                      {/* MATCHED SHADOW */}
                      <div className="vinyl-table-shadow-shop shadow-front-shop"></div>
                    </div>

                    <div
                      className={
                        viewMode === "grid"
                          ? "new-business__card-content"
                          : "new-business__card-content col-md-8"
                      }
                    >
                      <h4 className="fw-bold">
                        {item.titleEn?.length > 40
                          ? item.titleEn?.slice(0, 40) + "…"
                          : item.titleEn}
                      </h4>

                      <h3 className="new-business__card-type fw-bold">
                        {item.artistEn}
                      </h3>

                      <div className="d-flex flex-row align-items-center justify-content-between gap-3 mt-2">
                        <p
                          className={`price mb-0 ${item.qty === 0 ? "out-of-stock-price" : ""}`}
                        >
                          {item.price} $
                        </p>

                        {item.qty === 0 && (
                          <p className="out-of-stock-text">Sold Out</p>
                        )}

                        <div className="d-flex gap-2 icon-group">
                          <Link
                            to={`/products/${item.id}`}
                            className="icon-btn-shop view-btn"
                            title="View"
                          >
                            <FiEye size={18} />
                          </Link>

                          <button
                            className="icon-btn-shop cart-btn"
                            title={
                              item.qty === 0 ? "Out of stock" : "Add to cart"
                            }
                            disabled={item.qty === 0}
                            onClick={(e) => {
                              if (item.qty > 0) {
                                const card = e.currentTarget.closest(
                                  ".new-business__card-container, .new-business__list-container",
                                );
                                const sourceImg = card?.querySelector(
                                  ".image-icon-wrapper img",
                                );
                                addToCart?.(item, 1, sourceImg);
                              }
                            }}
                          >
                            <FiShoppingCart size={18} />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
        {/* </div>
              </div>
            </div>
          )} */}
      </div>
    </>
  );
};

export default Shop;
